import * as actionTypes from './actionTypes';

export const updateAgGridState = (tableTypeData) => ({
  type: actionTypes.UPDATE_AG_GRID_STATE,
  tableTypeData
});